import { client } from '@iris/content';
import { PortableTextTypeComponent } from '@portabletext/react';
import { getImageDimensions, SanityImageAsset } from '@sanity/asset-utils';
import urlBuilder from '@sanity/image-url';

import { Media } from './Media';

export const Image: PortableTextTypeComponent<SanityImageAsset> = ({ value }) => {
  let width: number;
  let height: number;
  let src: string;

  try {
    const dims = getImageDimensions(value);
    width = dims.width;
    height = dims.height;
    src = urlBuilder(client).image(value).width(1600).fit('max').auto('format').url();
  } catch {
    return null;
  }

  return (
    <Media>
      <img
        src={src}
        alt=""
        loading="lazy"
        style={{
          aspectRatio: `${width} / ${height}`,
        }}
      />
    </Media>
  );
};
